import React, { useState } from "react";
import { Form } from "react-bootstrap";

const FilterSelect = ({ onFilterChange }) => {
  const [selectedFilter, setSelectedFilter] = useState("7days");

  const filters = [
    { label: "Last 7 Days", value: "7days" },
    { label: "Last 6 Months", value: "6months" },
    { label: "Last 1 Year", value: "1year" },
  ];

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedFilter(value);
    if (onFilterChange) onFilterChange(value); // Call parent function if provided
  };

  return (
    <Form.Group>
      <Form.Select value={selectedFilter} onChange={handleChange}>
        {filters.map((filter) => (
          <option key={filter.value} value={filter.value}>
            {filter.label}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
};

export default FilterSelect;